import { createAsyncThunk } from "@reduxjs/toolkit";
import { t } from "ttag";

import * as productsAPI from "../../../api/products";
import { IProductID } from "../../../models/nominals";
import { IAPIPrice } from "../../../models/prices";
import { HttpError } from "../../../utils/ajax";

export const loadPrice = createAsyncThunk<
    IAPIPrice,
    { productID: IProductID; quantity: number },
    { rejectValue: { reason: string; isStockError: boolean } }
>(
    "configurator/loadPrice",
    async ({ productID, quantity }, { rejectWithValue }) => {
        const productURL = productsAPI.getProductURL(productID);
        try {
            return await productsAPI.getProductPrice(productURL, quantity);
        } catch (err) {
            if (err instanceof HttpError && err.status === 406) {
                return rejectWithValue({
                    reason: "",
                    isStockError: true,
                });
            }
            if (err instanceof HttpError) {
                return rejectWithValue({
                    reason: t`Unable to load pricing. Please try again.`,
                    isStockError: false,
                });
            }
            throw err;
        }
    },
);
